import type { FC } from "react";
import Tile from "../../assets/Tile";
import TileGlyph from "../../assets/TileGlyph";
import type { HistoryTotals } from "../../types";
import AmountPill from "../AmountPill";

type Props = {
  totals: HistoryTotals;
};

const AllRewardsTotals: FC<Props> = ({ totals }) => (
  <div data-slot="all-rewards-totals" className="flex flex-col gap-1 px-3 pb-3">
    <div className="mb-2 h-px bg-foreground/10" />
    {totals.byType.map((total) => (
      <div key={total.type} className="flex items-center gap-3">
        <Tile type={total.type} size="28">
          <TileGlyph type={total.type} />
        </Tile>
        <span className="flex-1 font-semibold text-foreground text-sm">
          {total.label}
        </span>
        <AmountPill amount={total.amount} />
      </div>
    ))}
  </div>
);

export default AllRewardsTotals;
